import { Box, Stack } from "@mantine/core";
import React from "react";
import { useHistory } from "react-router-dom";
import { FailedAlert, MCLoader } from "../../../../components";
import { useAppSelector } from "../../../../hooks";
import { useGetProjectByProjectIdIssueboardAndIssueBoardIdQuery } from "../../../../../openapi";
import { getIssueBoardIdFromUrl } from "../issueUtils";
import IssueAccessSettings from "./IssueAccessSettings";
import IssueBoardBuckets from "./IssueBoardBuckets";
import IssueBoardFilesStats from "./IssueBoardFilesStats";
import IssueBoardGanttSettings from "./IssueBoardGanttSettings";
import IssueBoardTypes from "./IssueBoardTypes";
import IssueColumnSettings from "./IssueColumnSettings";
import IssueColumnSettingsTasks from "./IssueColumnSettingsTasks";
import IssueCommonSettings from "./IssueCommonSettings";
import IssueOtherAttributesConfig from "./IssueOtherAttributesConfig";
import IssuePredefinedTags from "./IssuePredefinedTags";
import MoveIssueBoardToOtherProject from "./MoveIssueBoardToOtherProject";
import IssueRisiko from "./Risiko/IssueRisiko";

const IssueSettingsTab: React.FC = () => {
  const history = useHistory();
  const issueBoardId = getIssueBoardIdFromUrl(history.location.pathname);

  const project = useAppSelector((state) => state.adminReducer.project);

  const {
    data: issueBoard,
    isLoading: boardLoading,
    error,
  } = useGetProjectByProjectIdIssueboardAndIssueBoardIdQuery({
    projectId: project._id,
    issueBoardId,
  });

  return (
    <Box p="md" bg={"gray.0"} h="100%" style={{ overflow: "auto" }}>
      {error != null && <FailedAlert />}
      {boardLoading && <MCLoader loading={boardLoading} />}
      {issueBoard && (
        <Stack gap="md">
          <IssueAccessSettings issueBoard={issueBoard} />
          <IssueCommonSettings issueBoard={issueBoard} />
          <IssueBoardBuckets issueBoard={issueBoard} />
          <IssueBoardTypes issueBoard={issueBoard} />
          <IssueOtherAttributesConfig issueBoard={issueBoard} taskOrIssue="ISSUE" />
          <IssueOtherAttributesConfig issueBoard={issueBoard} taskOrIssue="TASK" />
          <IssueColumnSettings issueBoard={issueBoard} />
          <IssueColumnSettingsTasks issueBoard={issueBoard} />
          <IssuePredefinedTags issueBoard={issueBoard} />
          <MoveIssueBoardToOtherProject issueBoard={issueBoard} />
          <IssueRisiko issueBoard={issueBoard} />
          <IssueBoardGanttSettings issueBoard={issueBoard} />
          <IssueBoardFilesStats />
          {/* Extra bottenmarginal motsvarande tidigare tom div */}
          <Box h={100} />
        </Stack>
      )}
    </Box>
  );
};

export default IssueSettingsTab;
